import { Component, OnInit, ViewChild, OnDestroy, Input } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MsalService } from '@azure/msal-angular';

@Component({
	selector: 'ifective-user',
	templateUrl: './user.component.html',
	styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

	@Input() isAuthenticated: boolean;

	@ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
	public name: string;

	constructor(private msalService: MsalService) { }

	async ngOnInit() {

		if (this.isAuthenticated) {
			const account = this.msalService.instance.getActiveAccount();
			
			if (account) {
			  this.name = account.username; // Or account.name depending on what you need
			}
		}
	}
}